<template>
  <div class="body">
    <div class="title">
      <div>基本信息</div>
    </div>
    <a-form class="form" :form="form">
      <a-form-item label="头像">
        <a-upload
          name="avatar"
          list-type="picture-card"
          class="avatar-uploader"
          :disabled="true"
        >
          <img
            style="width: 100px; height: 140px"
            v-if="img_avatar_full"
            :src="img_avatar_full"
            alt="avatar"
          />
          <img
            class="notChoose"
            src="../../assets/images/expert/zjk-Upload avatar@2x.png"
            v-else
          />
        </a-upload>
      </a-form-item>

      <a-row>
        <a-col :span="12">
          <a-form-item label="姓名">
            <a-input
              :disabled="true"
              style="width: 400px"
              v-decorator="['name']"
            />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="艺名/笔名">
            <a-input
              :disabled="true"
              style="width: 400px"
              v-decorator="['stage_name']"
            />
          </a-form-item>
        </a-col>
      </a-row>

      <a-form-item label="性别">
        <a-input v-if="sex === 1" :disabled="true" value="男"> </a-input>
        <a-input v-if="sex === 0" :disabled="true" value="女"> </a-input>
      </a-form-item>

      <a-row>
        <a-col :span="12">
          <a-form-item label="民族">
            <a-input
              :disabled="true"
              v-decorator="['nation']"
              style="width: 240px"
            >
            </a-input>
          </a-form-item>
        </a-col>

        <a-col :span="6">
          <a-form-item label="籍贯">
            <a-input :disabled="true" v-decorator="['nation_place']" />
          </a-form-item>
        </a-col>
      </a-row>

      <a-form-item label="出生日期">
        <a-input :disabled="true" v-decorator="['birthday']" />
      </a-form-item>

      <a-row>
        <a-col :span="12">
          <a-form-item label="身份证号">
            <a-input
              :disabled="true"
              style="width: 400px"
              v-decorator="['idcard']"
            />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="电话号码">
            <a-input
              :disabled="true"
              style="width: 400px"
              v-decorator="['mobile']"
            />
          </a-form-item>
        </a-col>
      </a-row>

      <a-form-item label="电子邮箱">
        <a-input
          :disabled="true"
          style="width: 400px"
          v-decorator="['email']"
        />
      </a-form-item>

      <a-form-item label="入会时间">
        <a-input :disabled="true" v-decorator="['join_time']" />
      </a-form-item>

      <a-row>
        <a-col :span="12">
          <a-form-item label="艺术门类">
            <a-input :disabled="true" v-decorator="['artValue']"> </a-input>
          </a-form-item>
        </a-col>
        <a-col :span="6">
          <a-form-item label="现所在地">
            <a-input :disabled="true" v-decorator="['addressValue']" />
          </a-form-item>
        </a-col>
      </a-row>

      <a-row>
        <a-col :span="12">
          <a-form-item label="微博号">
            <a-input
              :disabled="true"
              style="width: 400px"
              v-decorator="['weibo']"
            />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="微信号">
            <a-input
              :disabled="true"
              style="width: 400px"
              v-decorator="['weixin']"
            />
          </a-form-item>
        </a-col>
      </a-row>

      <a-form-item label="办公地址">
        <a-input
          :disabled="true"
          style="width: 1000px"
          v-decorator="['address']"
        />
      </a-form-item>

      <a-row>
        <a-col :span="12">
          <a-form-item label="行政职务">
            <a-input
              :disabled="true"
              style="width: 400px"
              v-decorator="['xz_job']"
            />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="文联职位">
            <a-input
              :disabled="true"
              style="width: 400px"
              v-decorator="['wl_job']"
            />
          </a-form-item>
        </a-col>
      </a-row>

      <a-row>
        <a-col :span="12">
          <a-form-item label="协会职位">
            <a-input
              :disabled="true"
              style="width: 400px"
              v-decorator="['xh_job']"
            />
          </a-form-item>
        </a-col>
        <!-- <a-col :span="8">
          <a-form-item label="所在协会">
            <a-select style="width: 240px">
              <a-select-option value="jack"> Jack </a-select-option>
            </a-select>
          </a-form-item>
        </a-col> -->
      </a-row>

      <a-form-item label="个人简历">
        <a-textarea
          style="cursor: default; border: 1px solid #e6e7e8"
          :disabled="true"
          v-decorator="['synopsis']"
          :auto-size="{ minRows: 8 }"
        />
      </a-form-item>
    </a-form>
  </div>
</template>

<script>
import ExpertServices from "../../xx-vue/services/expert";
import UserServices from "../../xx-vue/services/user";
export default {
  beforeCreate() {
    this.form = this.$form.createForm(this, { name: "normal_login" });
  },
  mounted() {
    this.initData();
  },
  data() {
    return {
      img_avatar_full: "",
      sex: "",
      userInfo: {},
    };
  },
  methods: {
    async initData() {
      const userInfo = await UserServices.getCurrentUserAsync();
      this.userInfo = userInfo.data;
      const result = await ExpertServices.expertDetailAsync({
        id: this.userInfo.expert_info.id,
      });
      this.img_avatar_full = result.data.img_avatar_full;
      this.sex = result.data.sex;
      let arts = (result.data.art_category_name || []).join("，");
      const addressValue =
        result.data.province_name +
        "" +
        result.data.city_name +
        "" +
        result.data.district_name;
      this.form.setFieldsValue({
        name: result.data.name,
        stage_name: result.data.stage_name,
        birthday: result.data.birthday,
        idcard: result.data.idcard,
        mobile: result.data.mobile,
        email: result.data.email,
        join_time: result.data.join_time,
        nation: result.data.nation_full,
        nation_place: result.data.nation_place_full,
        weibo: result.data.weibo,
        weixin: result.data.weixin,
        address: result.data.address,
        xz_job: result.data.xz_job,
        wl_job: result.data.wl_job,
        xh_job: result.data.xh_job,
        synopsis: result.data.synopsis,
        artValue: arts,
        addressValue: addressValue,
      });
    },
  },
};
</script>

<style lang="less" scoped>
/deep/ .ant-form-item label {
  color: #656565;
}

// /deep/ {

// }
/deep/ .ant-upload.ant-upload-select-picture-card {
  background-color: unset;
  border: none;
}
/deep/ textarea.ant-input {
  width: 1000px;
  resize: none;
}

/deep/ .artTag .ant-form-item-children {
  display: flex;
}

/deep/ .ant-upload.ant-upload-select-picture-card > .ant-upload {
  padding: 0;
  display: flex;
  align-items: center;
}
/deep/ .ant-upload-picture-card-wrapper {
  width: 135px;
}
/deep/ .ant-input[disabled] {
  border: none;
  height: unset;
  background-color: white;
  padding-top: 14px;
  padding-bottom: 14px;
  font-size: 18px;
  color: #333333;
  text-indent: 10px;
  cursor: default;
}
/deep/ .ant-input:focus {
  box-shadow: none;
}
/deep/ .has-error .ant-input,
.has-error .ant-input:hover {
  border: none;
  height: unset;
  background-color: #f6f6f6;
  padding-top: 14px;
  padding-bottom: 14px;
  font-size: 18px;
  color: #989898;
  text-indent: 10px;
}
/deep/ .ant-select-selection--single {
  color: #989898;
  height: unset;
  padding-top: 12px;
  padding-bottom: 12px;
  padding-left: 12px;
}

/deep/ .ant-cascader-picker {
  border: 1px solid #e6e7e8;
  width: 240px;
  color: #989898;
}

/deep/ .ant-calendar-picker-input.ant-input {
  width: 240px;
  background-color: white;
  border: 1px solid #e6e7e8;
}

/deep/ .ant-form-item-label {
  text-align: center;
  min-width: 90px;
}
.body {
  border: 1px solid #e6e7e8;
  .title {
    padding-left: 36px;
    padding-top: 24px;
    font-size: 18px;
    font-weight: bold;
    color: #333333;
    border-bottom: 2px solid #e6e7e8;
    margin-bottom: 50px;
    div {
      display: inline-block;
      padding-bottom: 10px;
      border-bottom: 2px solid #e24141;
    }
  }

  .form {
    padding: 0 22px;
    .notChoose {
      width: 100px;
      height: 140px;
    }
    .ant-form-item {
      display: flex;
      align-items: center;
    }
  }
}
</style>